/**
 * Password Protect Page (PPWP) validates the page password via AJAX (using
 * jQuery's $.ajax, which is always XHR-based, never fetch) and, on success,
 * replaces the form with the returned post content client-side. That
 * replacement can come back empty for block-based content rendered outside
 * the normal query loop, leaving the page blank until a manual refresh.
 * Rather than overriding the plugin's own submit handler, patch
 * XMLHttpRequest to watch for its AJAX call to succeed and reload the page -
 * the reload re-runs the full page request, which renders correctly.
 */
export function initPasswordPageProtectReload() {
    const originalSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function (body) {
        const isPasswordValidation = typeof body === 'string' &&
            body.includes('action=ppw_validate_password');
        if (!isPasswordValidation) {
            originalSend.call(this, body);
            return;
        }
        this.addEventListener('load', () => {
            try {
                const response = JSON.parse(this.responseText);
                if (response?.success) {
                    window.location.reload();
                }
            }
            catch {
                // Response wasn't JSON - nothing to react to.
            }
        });
        originalSend.call(this, body);
    };
}
